import React from 'react';
import { Control, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import { LabelledSelectFormHook } from '../../../../../../components/LabelledSelectFormHook';
import { SelectOption } from '../../../../../../components/Select';
import { JobPageGroupHeader } from '../../JobPageGroupHeader';
import { ApplicationFormTemplateBody } from './ApplicationFormTemplateBody';
import { ApplicationFormTemplateService } from '../../../../../../services/applicant_tracking/ApplicationFormTemplateService';
import { CreateJobDto } from '../../../../../../services/applicant_tracking/JobService/CreateJobDto';
import { ApplicationFormTemplate } from '../../../../../../entities/applicant_tracking/ApplicationFormTemplate';

interface PropTypes {
  applicationFormTemplates: ApplicationFormTemplate[];
  watch: UseFormWatch<CreateJobDto>;
  register: UseFormRegister<CreateJobDto>;
  formControl: Control<CreateJobDto>;
}

export async function loadApplicationFormTemplates(): Promise<
  ApplicationFormTemplate[]
> {
  return ApplicationFormTemplateService.list();
}

function mapApplicationFormTemplateToOption(
  aft: ApplicationFormTemplate,
): SelectOption {
  return {
    value: aft.id.toString(),
    label: aft.template.name,
  };
}

export function ApplicationFormBody(props: PropTypes) {
  const watchTemplateId = props.watch('applicationFormTemplateId');
  const applicationFormTemplateOptions: SelectOption[] =
    props.applicationFormTemplates.map((aft) =>
      mapApplicationFormTemplateToOption(aft),
    );

  return (
    <>
      <JobPageGroupHeader
        title='Form Template'
        description='Select the template to start with'
        mandatory={true}
        lastElement={true}
      >
        <Row>
          <Col xs='3'>
            <LabelledSelectFormHook<CreateJobDto>
              label={'Default Templates'}
              placeholder={'Select template'}
              formHookContext={{
                controllerName: 'applicationFormTemplateId',
                formControl: props.formControl,
                required: true,
              }}
              options={applicationFormTemplateOptions}
            />
          </Col>
        </Row>
      </JobPageGroupHeader>
      {watchTemplateId != null && (
        <ApplicationFormTemplateBody
          applicationFormTemplate={props.applicationFormTemplates.find(
            (el) => el.id?.toString() == watchTemplateId,
          )}
          register={props.register}
        />
      )}
    </>
  );
}
